import { Component, computed, inject } from "@angular/core";
import { L2vpnSubscriptionDetailsGQL, L2vpnSubscriptionDetailsQuery } from "../../../../gql/generated-ingestor";
import { GenericSubscriptionComponent } from "../generic-subscription";
import { L2vpnSubscriptionDetails } from "../../types";
import { ApolloQueryResult } from "@apollo/client";

import { TranslateModule } from "@ngx-translate/core";
import { PageComponent } from "../../../../components/page/page";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { EnabledPipe } from "../../../../helpers/enabledpipe/enabledpipe";
import { SelfserviceToggleComponent } from "../../../../components/selfservice/selfservice-toggle/selfservice-toggle";
import { PageTabComponent } from "../../../../components/subscription-detail/page-tab/page-tab";
import { ServiceSpeedPipe } from "../service-speed-pipe/service-speed-pipe";
import { TabbedDetailContainer } from "../../../../components/subscription-detail/tabbed-detail-container/tabbed-detail-container";
import { NetworkgraphComponent } from "../../../../components/subscription-detail/networkgraph/networkgraph";
import { LinechartComponent } from "../../../../components/subscription-detail/linechart/linechart";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { L2vpnShortCutMenuComponent } from "./components/l2vpn-shortcut-menu/l2vpn-shortcut-menu";
import { NotFoundComponent } from "../../../../components/common/not-found/not-found";
import { LoaderComponent } from "../../../../components/common/loader/loader";
import { NotAuthorizedComponent } from "../../../../components/common/not-authorized/not-authorized";

@Component({
  selector: "l2vpn-subscription",
  templateUrl: "l2vpn-subscription.html",
  imports: [
    AliasEditorComponent,
    EnabledPipe,
    L2vpnShortCutMenuComponent,
    LinechartComponent,
    LoaderComponent,
    NetworkgraphComponent,
    NotAuthorizedComponent,
    NotFoundComponent,
    PageComponent,
    PageTabComponent,
    SelfserviceToggleComponent,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    SubscriptionDetailHeader,
    TabbedDetailContainer,
    ThirdPartyServiceIdsRowContentComponent,
    TranslateModule,
  ],
})
export class L2vpnSubscriptionComponent extends GenericSubscriptionComponent<
  L2vpnSubscriptionDetailsGQL,
  L2vpnSubscriptionDetailsQuery,
  L2vpnSubscriptionDetails
> {
  protected query = inject(L2vpnSubscriptionDetailsGQL);

  private circuits = computed(() => this.subscription()?.circuits);

  protected speedPolicer = computed(() => this.circuits()[0]?.speedPolicer);
  protected protection = computed(() => this.subscription().protection);
  protected topology = computed(() => this.subscription().topology);
  protected domain = computed(() => this.subscription().domain);
  protected serviceSpeed = computed(() => this.subscription().serviceSpeed);
  protected firewallEnabled = computed(() => this.subscription().firewallEnabled);

  protected canUpdateSpeedPolicer = computed(
    () => this.circuits().length > 0 && this.circuits()[0].speedPolicer !== null,
  );

  protected isSelfServiceEnabled = computed(
    () =>
      !this.isDirty()
      && this.auth.isSelfServiceEnabled
      && this.auth.hasRole(["Infraverantwoordelijke"])
      && this.auth.isCurrentOrganisation(this.customerId()),
  );

  protected onQuerySuccess = (result: ApolloQueryResult<L2vpnSubscriptionDetailsQuery>) => result.data.l2vpnDetails;
}
